<template>
  <div>
    <h1>Selo Site Seguro</h1>
    <div class="texto">
      <p>
        A Soluti oferece o Selo Site Seguro para certificados de equipamento (SSL). Este selo garante
        que o site onde ele aparece utiliza certificado digital ICP-Brasil nas conexões seguras, através do protocolo HTTPS.
      </p>
      <br>
      <p>
        Ao ver este selo em algum site, clique sobre ele e confirme se o site está utilizando corretamente
        o certificado emitido pela AC El Salvador:
        <br><br>
        <img src='https://selo.ca.inf.br/selo-soluti-grande.png' alt="site seguro" style="border: none;">
      </p>
      <br><br>
    </div>

    <div class="texto">
      <ul class="lista-downloads"><li class="prod">Quem pode utilizar</li></ul>
      <p>
        Todos os sites que utilizam certificados SSL emitidos na cadeia da AC El Salvador
        podem utilizar o selo.
      </p>

      <br><br>

      <ul class="lista-downloads"><li class="prod">Como instalar o selo</li></ul>
      <p>
        A instalação do selo é simples. Basta inserir em seu site um pequeno código HTML/JavaScript e o
        selo será exibido sempre que uma conexão HTTPS for estabelecida.
        <br><br>
        Para criar o código para seu site, preencha as opções abaixo:
        <br><br>

        <form id="formSelo" onsubmit="return false">
          Endereço do site:<br>
          <input type="text" size="40" id="urlselo" v-model.lazy="urlsite" style="width: 95%; border: 1px #e0e0e0 solid; padding: 2px;">
    			<br><br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="1" v-model="fundo"> Fundo claro - Grande
    			<br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="2" v-model="fundo"> Fundo claro - Médio
    			<br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="3" v-model="fundo"> Fundo claro - Pequeno
    			<br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="4" v-model="fundo"> Fundo escuro - Grande
    			<br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="5" v-model="fundo"> Fundo escuro - Médio
    			<br>
    			<input type="radio" id="tiposelo" name="tiposelo" value="6" v-model="fundo"> Fundo escuro - Pequeno
    			<br><br>
    			Aparência do Selo:
    			<br>
    			<div id="exemploSelo" style="padding: 10px; text-align: center;" :style="'background-color: ' + corfundo">
            <img :src="'https://selo.ca.inf.br/'+imagem" style="border: none;">
    			</div>

          <br><br>
    			Código para o Selo (JavaScript):<br/>
    			<textarea id="selo1" readonly="readonly" style="width: 95%; border: 1px #e0e0e0 solid; padding: 2px; font-size: x-small;"
            rows="5" onclick="this.select()">{{ seloJavascript }}</textarea>

    			<br><br>
    			Código para o Selo (HTML simples):<br/>
    			<textarea id="selo2" readonly="readonly" style="width: 95%; border: 1px #e0e0e0 solid; padding: 2px; font-size: x-small;"
            rows="5" onclick="this.select()">{{ seloHtml }}</textarea>
    			<br>
        </form>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        urlsite: "https://",
        fundo: "1",
        imagem: "selo-soluti-grande.png",
        corfundo: "#FFFFFF"
      };
    },
    watch: {
      fundo(value) {
        switch( value ) {
          case '1':
            this.imagem = 'selo-soluti-grande.png';
            this.corfundo = '#FFFFFF';
            break;
          case '2':
            this.imagem = 'selo-soluti-medio.png';
            this.corfundo = '#FFFFFF';
            break;
          case '3':
            this.imagem = 'selo-soluti-pequeno.png';
            this.corfundo = '#FFFFFF';
            break;
          case '4':
            this.imagem = 'selo-soluti-branco-grande.png';
            this.corfundo = '#404040';
            break;
          case '5':
            this.imagem = 'selo-soluti-branco-medio.png';
            this.corfundo = '#404040';
            break;
          case '6':
            this.imagem = 'selo-soluti-branco-pequeno.png';
            this.corfundo = '#404040';
            break;
        }
      }
    },
    computed: {
      seloJavascript() {
        if( this.urlsite == 'https://' || this.urlsite == '' ) return '';

        return "<a href='https://selo.ca.inf.br/' id='linkSiteSeguroSoluti' onclick='return abrirSiteSeguroSoluti()'><img \n" +
        "src='https://selo.ca.inf.br/" + this.imagem +
        "' alt='Selo Site Seguro Soluti' id='seloSiteSeguroSoluti' style='display: none;'></a> \n" +
        "<script type='text/javascript'> \n" +
        "if(document.location.protocol == 'https:') document.getElementById('seloSiteSeguroSoluti').style.display=''; \n" +
        "function abrirSiteSeguroSoluti() { \n" +
        "var url = 'https://selo.ca.inf.br/'; if(typeof btoa == 'function') url = url+'?site='+btoa(window.location.protocol+'//'+window.location.host+'/'); \n" +
        "window.open(url, 'SiteSeguroSoluti', 'scrollbars=yes,resizable=yes,width=450,height=600'); return false; \n" +
        "} \n" +
        "<\/script>";
      },
      seloHtml() {
        if( this.urlsite == 'https://' || this.urlsite == '' ) return '';

        var url = "https://selo.ca.inf.br/";
        if( (typeof btoa == 'function') ) url = url + '?site=' + btoa( this.urlsite );

        return "<a href='" + url + "' id='linkSiteSeguroSoluti'><img \n" +
			     "src='https://selo.ca.inf.br/" + this.imagem + "' alt='Selo Site Seguro Soluti' id='seloSiteSeguroSoluti'></a>";
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Selo.vue?43935ba2